/** Merge saved partner point engagements into admin engagement category config (calculator shape). */
export function buildEvaluationDataFromRecord(
  partnerEngagementCategoryList: any[] | null | undefined,
  record: any
): any[] {
  if (!partnerEngagementCategoryList?.length) return [];

  const engData = structuredClone(partnerEngagementCategoryList);
  engData.forEach((e_data: any) => {
    if (e_data.engagements?.length) {
      e_data.engagements = e_data.engagements.filter(
        (engagement: any) => engagement.status === "Active"
      );
      e_data.engagements.forEach((dp_data: any) => {
        if (dp_data.accelerator_value?.length) {
          dp_data.selectedValue = dp_data.accelerator_value[0]["option_value"];
          const existResult = (
            Number(
              Math.max(
                ...dp_data.accelerator_value.map((o: { option_value: any }) =>
                  Number(o.option_value)
                )
              )
            ) - Number(dp_data.selectedValue)
          ).toFixed(2);
          dp_data.potential_improvement = existResult;
        }
        if (record?.engagements?.length) {
          const existSummaryResponse = record.engagements.find(
            (s_data: any) =>
              s_data.activity_id === dp_data.ID &&
              s_data.category_id === dp_data.category_id
          );
          if (existSummaryResponse) {
            dp_data.selectedValue = existSummaryResponse.activity_value;
            dp_data.potential_improvement =
              existSummaryResponse.potential_improvement;
            dp_data.comment = existSummaryResponse.comment || [];
            dp_data.action = existSummaryResponse.action;
          }
        }
      });
    }
  });
  return engData;
}
